<template>
  <div class="home">
        <!--<av-line

          audio-src="https://sonic.dattalive.com/8132/stream"
          cors-anonym=true
        ></av-line>-->
        <vuetify-audio :file="file" color="success"></vuetify-audio>
  </div>
</template>
<script>
export default {
  name: 'Home',
  components: {
    VuetifyAudio: () => import('vuetify-audio'),
  },
  data: () => ({
    file: 'https://sonic.dattalive.com/8132/stream',
  }),
}
</script>
